import * as React from "react";
import { MetaTags } from "../../../head";

const Privacy = () => (
  <div className="tab-pane active">
    <MetaTags title="Chính sách bảo mật" />
    <h1>Chính sách bảo mật của Express Design</h1>
    <p>
      <em>Cập nhật: Ngày 13 tháng 07 năm 2017</em>
    </p>

    <h3>Chính sách bảo mật</h3>
    <p>
      Khi bạn sử dụng dịch vụ của Express Design (“ED", “Chúng tôi”, “của chúng
      tôi"), bạn hoàn toàn tin tưởng vào việc bảo mật các thông tin mà bạn cung
      cấp cho chúng tôi. Chính sách bảo mật này nhằm mục đích giúp bạn hiểu rõ
      những dữ liệu nào chúng tôi thu thập, tại sao chúng tôi thu thập và những
      gì chúng tôi xử lý với dữ liệu đó.
    </p>

    <p>
      <b>Các thuật ngữ:</b>
    </p>
    <ul>
      <li>
        <b>Thông tin cá nhân:</b> Đây là thông tin bạn cung cấp cho chúng tôi để
        nhận dạng cá nhân bạn, chẳng hạn như tên, địa chỉ email, số điện thoại
        hay các dữ liệu khác.
      </li>
      <li>
        <b>Cookie:</b> Cookie là một tệp nhỏ chứa một chuỗi các ký tự được gửi
        tới máy tính của bạn khi bạn truy cập vào website của chúng tôi. Khi bạn
        truy cập lại trang web, cookie cho phép ED đó nhận dạng trình duyệt của
        bạn. Cookie có thể lưu trữ tùy chọn của người dùng và các thông tin
        khác.
      </li>
      <li>
        <b>Bộ nhớ Cache:</b> Bộ nhớ cache là một kho lưu trữ trên thiết bị. Bộ
        nhớ này cho phép ứng dụng web chạy mà không cần kết nối internet và cải
        thiện hiệu suất của ứng dụng bằng cách cho phép tải nội dung nhanh hơn.
      </li>
      <li>
        <b>Địa chỉ IP:</b> Mọi thiết bị kết nối Internet được gán một số gọi là
        địa chỉ giao thức Internet (IP). Các số này thường được gán theo nhóm
        địa lý. Địa chỉ IP có thể thường được sử dụng để xác định vị trí mà một
        thiết bị đang kết nối Internet từ đó.
      </li>
      <li>
        <b>Tài khoản Express Design:</b> Bạn có thể truy cập một số dịch vụ của
        chúng tôi bằng cách đăng ký Tài khoản Express Design và cung cấp cho
        chúng tôi một số thông tin cá nhân (tên, địa chỉ email và mật khẩu của
        bạn). Thông tin tài khoản này sẽ được sử dụng để xác thực cá nhân khi
        bạn truy cập các dịch vụ của ED và bảo vệ tài khoản của bạn không bị
        người khác truy cập trái phép. Bạn có thể chỉnh sửa hoặc chấm dứt tài
        khoản của mình bất cứ lúc nào thông qua các cài đặt Tài khoản Express
        Design của bạn.
      </li>
    </ul>

    <h3>Thông tin chúng tôi thu thập</h3>

    <p>
      Chúng tôi thu thập các thông tin bạn cung cấp trực tiếp cho chúng tôi khi
      bạn đăng ký tài khoản, sử dụng dịch vụ sản phẩm, chúng tôi sẽ yêu cầu
      thông tin cá nhân, như tên, địa chỉ email, số điện thoại, tài khoản mạng
      xã hội của bạn để lưu trữ cùng với tài khoản của bạn.
    </p>

    <p>
      Chúng tôi cũng thu thập các thông tin về việc bạn sử dụng Dịch vụ, ví dụ
      như đăng tải nội dung, sản phẩm thiết kế lên trang web hoặc các trang liên
      kết của ED. ED tự động nhận và ghi lại thông tin nhật ký từ trình duyệt
      của bạn, bao gồm địa chỉ IP, cookie và các trang bạn yêu cầu nhằm mục đích
      nhận dạng và xác thực, cải tiến dịch vụ, nghiên cứu và báo cáo nặc danh.
    </p>

    <p>
      Chúng tôi có thể nhận được thông tin về bạn từ bên thứ ba khi bạn truy cập
      hay đăng nhập dịch vụ của chúng tôi thông qua bên thứ ba đó (Facebook,
      Google…). Thông tin thu thập là bất kỳ thông tin nào bạn đã cho phép bên
      thứ ba chia sẻ với chúng tôi và bất kỳ thông tin nào bạn đã công khai.
      Chúng tôi không chịu trách nhiệm với các thông tin hiển thị công khai khi
      lấy từ bên thứ ba (do bạn cung cấp trước đó). Bạn cũng có thể hủy liên kết
      tài khoản bên thứ ba khỏi Dịch vụ bằng cách điều chỉnh cài đặt của mình
      trên dịch vụ của bên thứ ba. Nếu bạn hủy liên kết tài khoản bên thứ ba của
      mình, chúng tôi sẽ không còn nhận được thông tin thu thập được về bạn liên
      quan đến dịch vụ đó.
    </p>

    <p>
      Quyền hạn và trách nhiệm của ED tách biệt - độc lập với các thông tin mà
      bạn cung cấp cho bên thứ ba vì thế hãy đảm bảo khi sử dụng thông tin của
      bên thứ ba để truy cập hệ thống ED là công khai, không vi phạm các điều
      khoản của bên thứ ba hoặc đang trong giai đoạn tranh chấp, có các vấn đề
      liên quan tới quyền sở hữu hoặc vi phạm pháp luật địa phương.
    </p>

    <p>
      Chúng tôi cũng có thể cần bạn đồng ý để thu thập thông tin không được quy
      định trong Chính sách bảo mật.
    </p>

    <h3>Cách chúng tôi sử dụng thông tin thu thập được</h3>
    <p>
      Chúng tôi sử dụng các thông tin thu thập được từ tất cả các dịch vụ của
      mình để cung cấp, duy trì, bảo vệ và cải thiện và phát triển các dịch vụ
      mới, đồng thời bảo vệ ED và người sử dụng Dịch vụ của chúng tôi. Chúng tôi
      phân tích thông tin để cung cấp cho Người sử dụng những sản phẩm thiết kế
      chất lượng, ứng dụng cao và phù hợp với nhu cầu.
    </p>
    <p>
      Chúng tôi có thể trực tiếp thu thập dữ liệu phân tích hoặc sử dụng công cụ
      phân tích của bên thứ ba để đo lường lưu lượng truy cập và xu hướng sử
      dụng cho Dịch vụ. Các công cụ này thu thập thông tin từ nhật ký trình
      duyệt hoặc thiết bị di động của bạn, gồm các trang mà bạn đã truy cập hay
      các thông tin khác giúp chúng tôi cải tiến Dịch vụ.
    </p>
    <p>
      Chúng tôi sẽ thông báo và đề nghị bạn đồng ý trước khi sử dụng thông tin
      cho một mục đích nào đó khác với các mục đích được nêu trong Chính sách
      bảo mật này.
    </p>

    <h3>Thông tin chúng tôi chia sẻ</h3>

    <p>
      ED không chia sẻ thông tin cá nhân mà chúng tôi tìm hiểu về bạn từ việc
      bạn sử dụng các trang web, sản phẩm và dịch vụ của chúng tôi với những
      người khác trừ khi được mô tả trong chính sách này. Chúng tôi không chia
      sẻ, bán, thuê hoặc trao đổi thông tin nhận dạng cá nhân của bạn với bên
      thứ ba vì mục đích quảng cáo của họ.
    </p>
    <p>
      Khi bạn đăng nội dung lên trang web hay các trang liên kết của chúng tôi,
      bạn có thể đăng nội dung bao gồm thông tin nhận dạng cá nhân về bản thân
      bạn. Bạn lưu ý bất kỳ thông tin nào bạn cung cấp trong các phạm vi này thì
      những người khác đều có thể đọc, thu thập và sử dụng chúng.
    </p>
    <p>
      Chúng tôi có thể sử dụng tên bạn hoặc thương hiệu của bạn để giới thiệu và
      quảng bá trên các trang liên kết của Chúng tôi với sự cho phép của bạn hay
      doanh nghiệp của bạn.
    </p>

    <h3>Chúng tôi bảo mật thông tin như thế nào</h3>

    <p>
      Chúng tôi áp dụng các giải pháp vật lý và kỹ thuật an toàn để bảo vệ thông
      tin mà chúng tôi thu thập được liên quan đến Dịch vụ. Thông tin tài khoản
      của bạn được bảo vệ bằng mật khẩu. Ngoài ra, mật khẩu của tài khoản của
      bạn được lưu trữ bằng thuật toán an toàn.
    </p>
    <p>
      Tuy nhiên, bạn cũng lưu ý rằng không có dữ liệu truyền qua Internet có thể
      được bảo đảm là an toàn 100%. Do đó, chúng tôi không thể bảo đảm hoặc đảm
      bảo an toàn cho bất kỳ thông tin nào bạn chuyển cho chúng tôi và bạn chấp
      nhận chịu rủi ro. Khi bạn đăng tải hay chia sẻ thông tin cho chúng tôi,
      chúng tôi nỗ lực để đảm bảo an ninh cho hệ thống của ED.
    </p>
    <p>
      Nếu chúng tôi phát hiện có sự vi phạm về an ninh hệ thống, chúng tôi sẽ cố
      gắng thông báo cho bạn qua các thông tin liên lạc bạn chia sẻ cho chúng
      tôi. Chúng tôi có thể đăng một thông báo trên các trang web của chúng tôi
      nếu vi phạm an ninh xảy ra. Chúng tôi cũng có thể gửi email cho bạn theo
      địa chỉ email bạn đã cung cấp cho chúng tôi trong những trường hợp này.
    </p>

    <h3>Thay đổi thông tin cá nhân</h3>

    <p>
      Bạn có thể chỉnh sửa thông tin tài khoản của bạn bất cứ lúc nào. Bạn có
      thể xóa tài khoản bằng cách truy cập vào trang cá nhân và xóa tài khoản
      hiện hành hoặc liên hệ với Trung tâm hỗ trợ của chúng tôi. Chúng tôi sẽ
      giữ lại thông tin của bạn cho đến khi tài khoản của bạn hoạt động hoặc nếu
      cần để cung cấp cho bạn các dịch vụ. Lưu ý, một số thông tin cá nhân như
      thông tin liên lạc của bạn chúng tôi có thể lưu trữ nhằm phục vụ trong các
      trường hợp bảo vệ lợi ích hợp pháp của chúng tôi.
    </p>

    <h3>Thay đổi chính sách bảo mật </h3>
    <p>
      Chúng tôi có thể điều chỉnh, sửa đổi hoặc cập nhật chính sách này. Chúng
      tôi sẽ thông báo cho bạn về những thay đổi quan trọng thông qua địa chỉ
      email mà bạn chia sẻ với chúng tôi hoặc bằng cách đặt một thông báo nổi
      bật trên trang của chúng tôi trước khi thay đổi có hiệu lực.
    </p>
    <p>
      Mọi câu hỏi thắc mắc vui lòng liên hệ với chúng tôi theo địa chỉ{" "}
      <a href="mailto:support@expressdesign.vn">support@expressdesign.vn</a>.
    </p>
  </div>
);

export default Privacy;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/Privacy.tsx